import { createAction, props } from '@ngrx/store';
import { AppStateFailure } from '@symphony-solo/shared/common-state/src';
import { CashlessPayment, CashlessResponse, Purses, PurseTopupOptions } from '../models';

export enum PursesActionTypes {
  GetPursesAction = '[Purses] GetPursesAction',
  GetPursesSuccessAction = '[Purses] GetPursesSuccess',
  GetPursesErrorAction = '[Purses] GetPursesError',
  SetPurseTopupOptionAction = '[Purses] SetPurseTopupOptionAction',
  SetPurseTopupOptionSuccessAction = '[Purses] SetPurseTopupOptionSuccessAction',
  SetPurseTopupOptionErrorAction = '[Purses] SetPurseTopupOptionErrorAction',
  ClearStateAction = '[Purses] ClearStateAction',
  cashlessPaymentAction = '[Purses] cashlessPaymentAction',
  cashlessPaymentSuccessAction = '[Purses] cashlessPaymentSuccessAction',
  cashlessPaymentErrorAction = '[Purses] cashlessPaymentErrorAction',
  SetSelectedPurseIDAction = '[Purses] SetSelectedPurseIDAction',
}

export const getPursesAction = createAction(PursesActionTypes.GetPursesAction);
export const getPursesSuccessAction = createAction(PursesActionTypes.GetPursesSuccessAction, props<{ purses: Purses[] }>());
export const getPursesErrorAction = createAction(PursesActionTypes.GetPursesErrorAction, props<{ failure: AppStateFailure }>());

export const ClearStateAction = createAction(PursesActionTypes.ClearStateAction, props<{ actionType: string }>());

export const SetPurseTopupOptionsAction = createAction(
  PursesActionTypes.SetPurseTopupOptionAction,
  props<{ purseTopupOptions: PurseTopupOptions }>()
);
export const SetPurseTopupOptionsSuccessAction = createAction(PursesActionTypes.SetPurseTopupOptionSuccessAction);
export const SetPurseTopupOptionsErrorAction = createAction(
  PursesActionTypes.SetPurseTopupOptionErrorAction,
  props<{ failure: AppStateFailure }>()
);

export const cashlessPaymentAction = createAction(PursesActionTypes.cashlessPaymentAction, props<{ cashlessPayment: CashlessPayment }>());
export const cashlessPaymentSuccessAction = createAction(
  PursesActionTypes.cashlessPaymentSuccessAction,
  props<{ cashlessResponse: CashlessResponse }>()
);
export const cashlessPaymentErrorAction = createAction(PursesActionTypes.cashlessPaymentErrorAction, props<{ failure: AppStateFailure }>());

export const SetSelectedPurseIDAction = createAction(PursesActionTypes.SetSelectedPurseIDAction, props<{ selectedPurseID: number }>());
